import { useState, useEffect } from 'react';
import { Login, ManageSubs } from '../components/Auth';

function Subscribe() {
    const [logged, setLogged] = useState(null);
    useEffect(() => {
        void (async () => {
            try {
                const loggedUser = await fetch('/api/auth/profile');
                const data = await loggedUser.json();
                if (data.user) { // update user profile if user has logged in
                    setLogged({
                        name: data.user.username,
                        email: data.user.email,
                        imageUrl: data.user.imageUrl
                    });
                } else
                    setLogged(null);
            } catch (err) {
                console.error(err);
            }
        })();
    }, []);

    return (
        <>
            {!logged && < Login />}
            {logged && < ManageSubs userEmail={logged?.email} />}
        </>
    );
};

export default Subscribe;